const RECETTE_PAGE_TITLE_SUFFIX = ' - Recette'

export function resolvePublicAppEnv(raw: unknown): string {
  return String(raw ?? '').trim().toLowerCase()
}

export function parsePublicBooleanEnv(raw: unknown): boolean {
  const normalized = String(raw ?? '').trim().toLowerCase()
  return normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on'
}

export function withRecettePageTitle(title: string | undefined | null, showRecetteBadge: boolean): string {
  const base = String(title ?? '').trim() || 'Mon Orga'
  if (!showRecetteBadge) {
    return base
  }
  if (base.toLowerCase().endsWith(' recette') || base.toLowerCase().endsWith(' - recette')) {
    return base
  }
  return `${base}${RECETTE_PAGE_TITLE_SUFFIX}`
}
